document.addEventListener("DOMContentLoaded", function () {
  const switcher = document.querySelector(".footer-language-switcher");
  if (!switcher) return;

  const state = switcher.querySelector(".footer-language-switcher__state");
  if (!state) return;

  // 状態クリックで開閉
  state.addEventListener("click", function (e) {
    e.stopPropagation();
    const isOpen = switcher.getAttribute("data-open") === "true";
    switcher.setAttribute("data-open", isOpen ? "false" : "true");
  });

  // ::after の擬似要素クリックでも開閉できるよう、switcher自体のクリックも拾う
  switcher.addEventListener("click", function (e) {
    if (e.target.closest(".footer-language-switcher__list")) {
      return;
    }
    if (e.target === state) {
      return;
    }
    e.stopPropagation();
    const isOpen = switcher.getAttribute("data-open") === "true";
    switcher.setAttribute("data-open", isOpen ? "false" : "true");
  });

  // ★ 言語選択ボタンクリック時の即時フィードバック
  const items = switcher.querySelectorAll(".footer-language-switcher__item");
  items.forEach(function (item) {
    item.addEventListener("click", function () {
      // ※ preventDefault しない（form送信は通常通り走らせる）

      // 1. 選択状態の即時切り替え
      items.forEach(function (i) { i.classList.remove("is-selected"); });
      item.classList.add("is-selected");

      // 2. 上部ラベルを即時更新
      state.textContent = item.textContent.trim();

      // 3. プルダウンを閉じる
      switcher.setAttribute("data-open", "false");

      // 4. 処理中状態を表示（CSSで見た目を制御）
      switcher.setAttribute("data-loading", "true");
    });
  });

  // 外側クリックで閉じる
  document.addEventListener("click", function (e) {
    if (!switcher.contains(e.target)) {
      switcher.setAttribute("data-open", "false");
    }
  });
});